import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ToastContainer } from 'react-toastify';
import ToasterHelper from '../../../shared/helpers/toaster.helper';
import Request from '../../../shared/request/Request';
import { isValidEmail } from '../../../shared/helpers/utils.helper';
import { API } from '../../../shared/constants/API';

const UserForgotPassword = () => {
  const { t } = useTranslation();
  const [validated, setValidated] = useState(false);
  const [email, setEmail] = useState('');
  const [emailInvalid, setEmailInvalid] = useState(false);

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.stopPropagation();

    setValidated(true);

    const form = event.currentTarget;
    const isFormValid = form.checkValidity();

    const isEmailFormatValid = isValidEmail(email);

    setEmailInvalid(!isEmailFormatValid);

    if (isFormValid && isEmailFormatValid) {
      Request.post(`${API.USERS_SERVICE}/forgotPassword`, {
        body: { email: email }
      })
        .then((response: any) => {
          ToasterHelper.notify(t('SIGN_IN.FORGOT_PASSWORD_EMAIL_SENT'), 'info');
        })
        .catch(error => {
          ToasterHelper.notify(t('ERRORS.AN_ERROR_OCCURRED'), 'error');
          console.log(error);
          return [];
        });
    }
  };

  return (
    <div className='mt-10'>
      <p className='text-center text-sm'>
        <b>{t('SIGN_IN.FORGOT_PASSWORD')}</b>
      </p>
      <ToastContainer />
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <div className='flex flex-col items-center'>
          <div className='flex flex-col items-center col-md-4 text-sm'>
            <div className='col-md-6'>{t('SIGN_IN.EMAIL') + ' *'}</div>
            <div className='col-md-6'>
              <Form.Group className='mb-6' controlId='email'>
                <Form.Control type='email' required onChange={handleEmailChange} value={email} placeholder={t('SIGN_IN.EMAIL') + ' *'} />
                <div>{emailInvalid && <small className='text-danger'>{t('SIGN_IN.VALIDATIONS.EMAIL_VALID')}</small>}</div>
              </Form.Group>
            </div>
          </div>
        </div>
        <div className='text-center mt-2'>
          <Button className='button-font-size background button-border-radius cursor-pointer' variant='primary' type='submit'>
            <b>{t('COMMON.SUBMIT')}</b>
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default UserForgotPassword;
